import { render } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=0c3dbfd0&scoped=true"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"

import "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=0c3dbfd0&scoped=true&lang=less"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3dbfd0"]])

export default __exports__